import React from 'react'
import Button from '@material-ui/core/Button'
import { useAuth } from 'lib/auth'
import {
  getRegistrationDisabled,
  getRegistrationButtonLabel,
} from '../registration-cta-utils'
import { useRegistrationInvite } from '../registration-invite'

const ActionButton = ({
  groupEvent,
  paymentRequired,
  steps,
  activeStep,
  type,
  component,
  to,
  onClick,
  className,
  reviewLabel = 'Review and Pay',
}) => {
  const { user } = useAuth()
  const { isValid: inviteValid } = useRegistrationInvite()
  const registrationDisabled = getRegistrationDisabled({
    user,
    groupEvent,
    inviteValid,
  })

  const nextStep = steps[activeStep + 1]
  const statusLabel = getRegistrationButtonLabel({
    user,
    groupEvent,
    paymentRequired: false,
    inviteValid,
  })
  const label =
    statusLabel !== 'Register'
      ? statusLabel
      : nextStep && nextStep.name === 'Waiver'
        ? 'Continue'
        : paymentRequired
          ? reviewLabel
          : 'Register'

  return (
    <Button
      variant="contained"
      color="primary"
      disabled={registrationDisabled}
      className={className}
      {...{ type, component, to, onClick }}
    >
      {label}
    </Button>
  )
}

export default ActionButton
